import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus4() {
  return (
    <BusDetailsCard
      busId="bus4"
      title="Bus 4 - Route Details"
      busName="Bus 4"
      vehicleNo="TN74D4234"
      backTo="/?buses=1"
    />
  );
}